import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const Kariire = props => {
  return <Dropdown.Static kubunKey='kariire' {...props} />
}
